// Produce a background color for the hash of a text
export const colorForText = (m: string, alpha: number) => {
  const colors = ["#c0392b", "#e74c3c", "#9b59b6", "#8e44ad", "#2980b9", "#3498db", "#1abc9c", "#16a085", "#27ae60", "#2ecc71", "#f1c40f", "#f39c12", "#e67e22", "#d35400", "#7b241c", "#943126", "#633974", "#5b2c6f", "#1a5276", "#21618c", "#117864", "#0e6655", "#196f3d", "#1d8348", "#9a7d0a", "#9c640c", "#935116", "#873600"];
  const firstLetter = m.toLowerCase().charCodeAt(0) + m.length;

  const listSize = colors.length;
  const idx = Math.abs(firstLetter % listSize);

  const hex = colors[idx];
  return hexToRGB(hex, alpha);
};

export const hexToRGB = (hex: string, alpha: number) => {
  const { r, g, b } = getRgbValues(hex);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};

export const isDarkColor = (hex: string) => {
  const { r, g, b } = getRgbValues(hex);
  return (r + g + b) < 382;
};

const getRgbValues = (hex: string) => {
  const isValidHexLength = hex[0] === "#" ? hex.length === 7 : hex.length === 6;
  if (!isValidHexLength) {
    throw new Error("Invalid hex value: " + hex);
  }
  const hexWithoutHash = hex[0] === "#" ? hex.slice(1) : hex;

  const r = parseInt(hexWithoutHash.slice(0, 2), 16);
  const g = parseInt(hexWithoutHash.slice(2, 4), 16);
  const b = parseInt(hexWithoutHash.slice(4, 6), 16);

  return { r, g, b };
};